module.exports = __webpack_public_path__ + "img/logo.871d62ae.png";